import React, { useState, useEffect } from 'react'
import { Offcanvas } from 'react-bootstrap'
import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tab'
import Button from 'react-bootstrap/Button'
import { PanelFooter, PanelHeader } from 'components/Panel'
import { LoadingSpinner } from 'components/LoadingSpinner'
import { EmptyTabContent, InfoTab } from './UserTabs.js'
import api from 'api/api'
import './styles.css'

function UserDetails({
	usuario,
	tiposDisponibles,
	mostrar,
	cancelar,
	// Nuevas props para pestañas personalizadas
	customTabs = [],
	isLoading = false
}) {
	const [activeTab, setActiveTab] = useState('info')
	const [estadisticas, setEstadisticas] = useState(null)
	const [loadingStats, setLoadingStats] = useState(false)

	// Determinar si el usuario es cliente para mostrar pestañas adicionales
	const isCliente = usuario?.tipo?.toLowerCase() === 'cliente'

	// Cargar estadísticas cuando se abre el panel y es un cliente
	useEffect(() => {
		const cargarEstadisticas = async () => {
			if (mostrar && isCliente && usuario?.id) {
				setLoadingStats(true)
				try {
					const { datos } = await api.get(`a/usuarios/${usuario.id}/estadisticas`)
					setEstadisticas(datos)
				} catch (error) {
					console.error('Error al cargar estadísticas:', error)
					setEstadisticas(null)
				} finally {
					setLoadingStats(false)
				}
			}
		}

		cargarEstadisticas()
	}, [mostrar, usuario?.id, isCliente])

	// Resetear la pestaña activa y estadísticas cuando cambia el usuario
	useEffect(() => {
		setActiveTab('info')
		setEstadisticas(null)
	}, [usuario])

	const handleClose = () => {
		cancelar()
	}

	// Preparar las pestañas disponibles
	const renderTabs = () => {
		// Siempre incluimos la pestaña de información
		const tabItems = [
			<Tab
				eventKey="info"
				title={<><i className="fa fa-user me-2"></i>Información</>}
				key="info"
			>
				<InfoTab
					usuario={usuario}
					estadisticas={estadisticas}
				/>
			</Tab>
		]

		// Si es cliente, añadimos las pestañas adicionales
		if (isCliente) {
			// Pestaña de pedidos
			tabItems.push(
				<Tab
					eventKey="pedidos"
					title={<><i className="fa fa-shopping-cart me-2"></i>Pedidos</>}
					key="pedidos"
				>
					{customTabs.find(tab => tab.key === 'pedidos')?.content ||
						<EmptyTabContent title="Pedidos" icon="shopping-cart" />}
				</Tab>
			)

			// Pestaña de historial
			tabItems.push(
				<Tab
					eventKey="historial"
					title={<><i className="fa fa-history me-2"></i>Historial</>}
					key="historial"
				>
					{customTabs.find(tab => tab.key === 'historial')?.content ||
						<EmptyTabContent title="Historial" icon="history" />}
				</Tab>
			)

			// Pestañas personalizadas adicionales
			customTabs
				.filter(tab => !['pedidos', 'historial'].includes(tab.key))
				.forEach(tab => {
					tabItems.push(
						<Tab
							key={tab.key}
							eventKey={tab.key}
							title={<>{tab.icon && <i className={`${tab.icon} me-2`}></i>}{tab.title}</>}
						>
							{tab.content || <EmptyTabContent title={tab.title} icon={tab.icon.replace('fa-', '')} />}
						</Tab>
					)
				})
		}

		return tabItems
	}

	return (
		<Offcanvas
			show={mostrar}
			onHide={handleClose}
			placement="end">
			<PanelHeader onClick={handleClose} iconClass="fa-arrow-left" btnText="Atrás" text="Detalles del Usuario" />

			<Offcanvas.Body id="ver-usuario">
				{isLoading || loadingStats ? (
					<div className="text-center my-5">
						<LoadingSpinner />
						<p className="mt-3">Cargando información del usuario...</p>
					</div>
				) : (
					<Tabs
						activeKey={activeTab}
						onSelect={(k) => setActiveTab(k)}
						className="mb-4"
					>
						{renderTabs()}
					</Tabs>
				)}
			</Offcanvas.Body>

			<PanelFooter>
				<Button
					variant="primary"
					onClick={cancelar}
				>
					Cerrar
				</Button>
			</PanelFooter>
		</Offcanvas>
	)
}

export default UserDetails